import PromotionSetData from "../data_json/promotion_set.json";
import groupPromotionSetData from "../data_json/grouppromotion_set.json";
import lpPromotionSetData from "../data_json/lppromotion_set.json";
import { getDiffDay } from "./ApiCommon";
import moment from "moment";

// promotion data 구하기 (쿠폰)
export const GetPromotionSetData = (pid) => {
  const Data = PromotionSetData.find((data) => data.PROM_ID === pid);
  return Data;
};

export const GetUsableCouponListByServId = (servid, couponList, forJoin) => {
  let cnt = 0;
  if (couponList !== undefined) {
    for (let i = 0; i < couponList.length; i++) {
      const couData = GetPromotionSetData(couponList[i].promid);

      // 모든 서비스에 다 적용 가능한 쿠폰인지,
      if (couData.PROM_SVCID === 0) {
        if (couData.PROM_USER === forJoin) {
          cnt = cnt + 1;
        }
      } else {
        if (couData.PROM_SVCID === servid && couData.PROM_USER === forJoin) {
          cnt = cnt + 1;
        }
      }
    }
  }
  console.log(cnt);
  return cnt;
};

// lppromotion data 구하기 (포인트)
export const GetLPPromotionSetData = (rid) => {
  const data = lpPromotionSetData.find((data) => data.LPPR_ID === rid);
  return data;
};

// grp_cd로 grouppromotion data 구하기 (그룹 데이터)
export const getGroupPromotionByGRPCD = (inputValue) => {
  // 대소문자 구분없어야 해서 모두 소문자로 바꿔서 찾는다.
  const grpPromoData = groupPromotionSetData.find(
    (data) => String(data.GRP_CD).toLowerCase() === inputValue.toLowerCase()
  );

  if (grpPromoData !== undefined) {
    return grpPromoData;
  } else {
    return null;
  }
};

// grp_id로 grouppromotion 구하기 (grppromotion)
export const getGroupPromotionByGRPID = (id) => {
  const data = groupPromotionSetData.find((data) => data.GRP_ID === id);
  return data;
};

export const checkPromotionType = (code) => {
  // type => -1: 유효하지 않은 코드, 0: 쿠폰 , 1: 포인트, 2: 키노 월별 포인트 (kinolight02)
  let type = -1;

  if (code.length < 16) {
    // 그룹코드
    const value = getGroupPromotionByGRPCD(code);

    if (value === null) {
      // 유효하지 않은 코드
      type = -1;
    } else {
      if (value.GRP_TYP === 0) {
        // 쿠폰
        type = 0;
      } else {
        // 포인트
        const code = String(value.GRP_CD).toLowerCase();
        const splitCode = code.split("_");
        if (splitCode[0] === "linkino") {
          // 키노 월별 포인트.
          // 해당 될 경우, /collabochk 를 확인해서 (cid = "kinolights02") 키노 회원이어야  만 포인트 등록을 보낸다.
          type = 2;
          // console.log("키노 포인트");
        } else {
          // 일반 포인트
          type = 1;
          // console.log("일반 포인트");
        }
      }
    }
  } else if (code.length === 16) {
    // 쿠폰
    type = 0;
  } else if (code.length === 18) {
    // 포인트
    type = 1;
  } else {
    // 유효하지 않은 코드
    type = -1;
  }
  return type;
};

// 유효한 promotion data 구하기 (쿠폰)
export const getCouponPromotionState = (pid) => {
  let type = 1; // 0: 정상, -1: 유효하지 않은 promotion id

  const data = GetPromotionSetData(pid);

  if (data) {
    if (
      getDiffDay(data.PROM_EDATE, moment().format("YYYY-MM-DD")) < 0 &&
      getDiffDay(data.PROM_SDATE, moment().format("YYYY-MM-DD")) >= 0
    ) {
      type = 0;

      return {
        data,
        type,
      };
    }
  } else {
    type = -1;

    return { type };
  }
};

// 유효한 promotion data 구하기 (쿠폰)
export const getValidPromotionData = () => {
  const data = PromotionSetData.filter((data) => {
    return (
      getDiffDay(data.PROM_EDATE, moment().format("YYYY-MM-DD")) < 0 &&
      getDiffDay(data.PROM_SDATE, moment().format("YYYY-MM-DD")) >= 0
    );
  });

  return data;
};

// 유효한 promotion data 구하기 (포인트)
export const getPointPromotionState = (pid) => {
  let type = 1; // 0: 정상, -1: 유효하지 않은 promotion id

  const data = GetLPPromotionSetData(pid);

  if (data) {
    if (
      getDiffDay(data.LPPR_EDATE, moment().format("YYYY-MM-DD")) < 0 &&
      getDiffDay(data.LPPR_SDATE, moment().format("YYYY-MM-DD")) >= 0
    ) {
      type = 0;

      return {
        data,
        type,
      };
    }
  } else {
    type = -1;

    return { type };
  }
};
